import { c as _c } from "react/compiler-runtime";
import { GroupsTable } from "@components/table/groups/groups-table";
import { GROUPS_TABLE_COLUMNS } from "@components/table/groups/groups-table-constants";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useGroupsPageBulkActions } from "@pages/groups/use-groups-page-bulk-actions";
/** Content to show for groups table */
export function GroupsPageTable(t0) {
  const $ = _c(19);
  const {
    companyId,
    groups,
    isLoading,
    sortBy,
    setSortBy
  } = t0;
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t1;
  if ($[0] !== groups) {
    t1 = {
      groups
    };
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const buttonComponents = useGroupsPageBulkActions(t1);
  let columns;
  let t2;
  if ($[2] !== canAssignManagers) {
    columns = canAssignManagers ? [...GROUPS_TABLE_COLUMNS] : GROUPS_TABLE_COLUMNS.filter(_temp);
    t2 = columns.filter(_temp2);
    $[2] = canAssignManagers;
    $[3] = columns;
    $[4] = t2;
  } else {
    columns = $[3];
    t2 = $[4];
  }
  const defaultVisibleColumns = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["options"];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== defaultVisibleColumns) {
    t4 = {
      nonConfigurableColumns: t3,
      defaultVisibleColumns
    };
    $[6] = defaultVisibleColumns;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== buttonComponents || $[9] !== companyId || $[10] !== groups || $[11] !== isLoading || $[12] !== setSortBy || $[13] !== sortBy) {
    t5 = <GroupsTable companyId={companyId} groups={groups} isLoading={isLoading} bulkActionButtons={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} />;
    $[8] = buttonComponents;
    $[9] = companyId;
    $[10] = groups;
    $[11] = isLoading;
    $[12] = setSortBy;
    $[13] = sortBy;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== columns || $[16] !== t4 || $[17] !== t5) {
    t6 = <ColumnPreferencesProvider tableKey="groups-table" columns={columns} options={t4}>{t5}</ColumnPreferencesProvider>;
    $[15] = columns;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp2(column_0) {
  return column_0 !== "options";
}
function _temp(column) {
  return column !== "members";
}